import React from "react";
import "./Feedback.scss";
import Button from "components/Buttons/Button";
import { useIntl } from "react-intl";


const Feedback = () => {
    const intl = useIntl();
    return (
        <Button
            to="https://myhr.feedback.wartsila.com/"
            size="small"
            className="feedback"
        >
            {intl.formatMessage({
                id: "feedback.button.text",
            })}
        </Button>
    )
}

export default Feedback;
